<mat-card class="control-listing"
          ngClass="{'shadow-device': device.$isShadow}">
    <div class="card-information device-card-header"
         [clDragElement]="shouldDrag()"
         (clDrag)="detailViewService.dragStart($event, device)"
         (clOver)="detailViewService.dragOver($event, module, null, device)"
         (clEnd)="detailViewService.dragEnd($event)"
         (clLeave)="detailViewService.leave($event)"
         fxLayout="row">
        <dl-device-status-cell [deviceStatusType]="device.deviceStatusType"
                               [deviceCategory]="device.category"
                               tooltipDirection="below">
        </dl-device-status-cell>
        <div class="device-card-title">
            <span title="Device Tag">
                {{ device.tag }}
            </span>
            <span class="device-category-sequence"
                  title="Category - Sequence">
                {{ device.category }} - {{ device.sequence }}
            </span>
        </div>
        <div fxFlex></div>
        <dl-device-card-controls [device]="device"
                              [(readerStatusView)]="readerStatusView">
        </dl-device-card-controls>
    </div>
    <mat-divider></mat-divider>
    <div class="device-card-body">
        <table class="cl-value-table animate-if"
               *ngIf="!readerStatusView">
            <tbody>
                <ng-container *ngIf="device.cellularDeviceStatus">
                    <tr>
                        <td>Cellular Status</td>
                        <td>
                            {{ device.cellularDeviceStatus | cellularDeviceStatusFormat: '('+
                            dateFormat + ')' }}
                        </td>
                    </tr>
                    <tr *ngIf="device.cellularDeviceStatus.activated">
                        <td>Activated</td>
                        <td>{{ device.cellularDeviceStatus.activated |
                            amDateFormat: dateFormat }}</td>
                    </tr>
                    <tr *ngIf="device.cellularDeviceStatus.lastConnected">
                        <td>Last Connected</td>
                        <td>{{ device.cellularDeviceStatus.lastConnected |
                            amDateFormat: dateFormat }}</td>
                    </tr>
                    <tr *ngIf="device.cellularDeviceStatus.lastDisconnected">
                        <td>Last Disconnected</td>
                        <td>{{ device.cellularDeviceStatus.lastDisconnected |
                            amDateFormat: dateFormat }}</td>
                    </tr>
                    <tr *ngIf="device.cellularDeviceStatus.error">
                        <td>Error</td>
                        <td>{{ device.cellularDeviceStatus.error }}</td>
                    </tr>
                </ng-container>
                <ng-container *ngIf="device.agent">
                    <tr>
                        <td>Is Agent Online</td>
                        <td>{{ device.agent.isAgentOnline }}</td>
                    </tr>
                    <tr>
                        <td>Agent Uptime</td>
                        <td>{{ device.agent.agentUptime }}</td>
                    </tr>
                </ng-container>
                <tr>
                    <td>Job Number</td>
                    <td>{{ device.jobNumber }}</td>
                </tr>
                <tr *ngIf="isPendingVersionAvailable">
                    <td>Pending Firmware Version</td>
                    <td>
                        <dl-device-status-pending-version-cell [item]="device">
                        </dl-device-status-pending-version-cell>
                    </td>
                </tr>
                <tr>
                    <td>Firmware Version</td>
                    <td>
                        <dl-device-status-firmware-version-cell [item]="device">
                        </dl-device-status-firmware-version-cell>
                    </td>
                </tr>
                <tr *ngIf="!isModule()">
                    <td>Template Version</td>
                    <td>
                        <dl-device-status-version-cell [item]="device">
                        </dl-device-status-version-cell>
                    </td>
                </tr>
                <tr *ngIf="isEditable()">
                    <td>Configuration</td>
                    <td>
                        <dl-device-status-configuration-cell [item]="device">
                        </dl-device-status-configuration-cell>
                    </td>
                </tr>
                <tr *ngIf="device.configuration">
                    <td>Modbus Id</td>
                    <td>
                        <dl-device-status-modbus-id-cell [item]="device">
                        </dl-device-status-modbus-id-cell>
                    </td>
                </tr>
                <tr *ngIf="device.lastUpdated">
                    <td>Last Updated</td>
                    <td>{{ device.lastUpdated| date:'medium' }}</td>
                </tr>
            </tbody>
        </table>
        <div *ngIf="readerStatusView"
             class="reader-status-wrapper animate-if">
            <dl-device-reader-status [item]="device"></dl-device-reader-status>
        </div>
    </div>
</mat-card>
